import React, { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { registerNotifier } from "../Services/Notifier";

const GlobalNotifier = () => {
  const [state, setState] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  useEffect(() => {
    registerNotifier(({ message, severity }) => {
      setState({
        open: true,
        message,
        severity,
      });
    });
  }, []);

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={() => setState((s) => ({ ...s, open: false }))}
    >
      <Alert
        onClose={() => setState((s) => ({ ...s, open: false }))}
        severity={state.severity}
        variant="filled"
        sx={{ minWidth: 300 }}
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalNotifier;
